import { useState, useEffect } from 'react';
import config from '../config';

export function RequerimientoModalImages({ onClose, requerimiento, visita }) {
  const [imagenesVisita, setImagenesVisita] = useState([]);
  useEffect(() => {
    obtenerImagenesVisita(visita);
  }, []);

  const obtenerImagenesVisita = async (visita) => {
    try {
      const response = await fetch(
        `${config.apiBaseUrl}/imagenes.php?visita=${visita}`
      );
      const data = await response.json();

      if (data && data[0].id_visita) {
        setImagenesVisita(data);
      }
    } catch (error) {
      setImagenesVisita([]);
    }
  };

  const [activeIndex, setActiveIndex] = useState(0);

  const handleSlideChange = (selectedIndex) => {
    setActiveIndex(selectedIndex);
  };

  return (
    <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
      <div className="modal-content">
        <div className="modal-header">
          <h4 className="mb-0">Visita Técnica: {requerimiento.detalle}</h4>
          <button onClick={onClose} className="btn-close"></button>
        </div>
        <div className="modal-body">
          <div id="myCarousel" className="carousel carousel-dark slide carousel-fade" data-bs-ride="carousel">
            <div className="carousel-inner">
              {imagenesVisita ? (
                imagenesVisita.map((imagen, index) => (
                  <div key={index} className={`carousel-item ${activeIndex === index ? 'active' : ''}`}>
                    <img
                      src={imagen.url_storage || imagen.imagen}
                      className="d-block w-100"
                      alt={`Slide ${index + 1}`}
                    />
                  </div>
                ))
              ) : (
                <div className="alert alert-warning" role="alert">
                  <i className="bi bi-exclamation-triangle me-2"></i>
                  No se encontraron imágenes asociadas a la visita técnica
                </div>
              )}
            </div>
            <button
              className="carousel-control-prev"
              type="button"
              data-bs-target="#myCarousel"
              data-bs-slide="prev"
              onClick={() => handleSlideChange((activeIndex - 1 + imagenesVisita.length) % imagenesVisita.length)}
            >
              <span className="carousel-control-prev-icon" aria-hidden="true"></span>
              <span className="visually-hidden">Anterior</span>
            </button>
            <button
              className="carousel-control-next"
              type="button"
              data-bs-target="#myCarousel"
              data-bs-slide="next"
              onClick={() => handleSlideChange((activeIndex + 1) % imagenesVisita.length)}
            >
              <span className="carousel-control-next-icon" aria-hidden="true"></span>
              <span className="visually-hidden">Siguiente</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
